import { render, staticRenderFns } from "./PreSettlement.vue?vue&type=template&id=bf3de570&scoped=true"
import script from "./PreSettlement.vue?vue&type=script&lang=js"
export * from "./PreSettlement.vue?vue&type=script&lang=js"
import style0 from "./PreSettlement.vue?vue&type=style&index=0&id=bf3de570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3de570",
  null
  
)

export default component.exports